import * as Sentry from "@sentry/react";

export function initSentry(): void {
  const dsn = import.meta.env.VITE_SENTRY_DSN;

  if (!dsn) {
    console.log("[Sentry] DSN not configured");
    return;
  }

  Sentry.init({
    dsn,
    environment: import.meta.env.MODE,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(),
    ],
    // Performance monitoring
    tracesSampleRate: 0.1,
    // Session replay - higher rate for admin tool with low traffic
    replaysSessionSampleRate: 0.5,
    replaysOnErrorSampleRate: 1.0,
    // Privacy
    beforeSend(event) {
      // Scrub sensitive data from breadcrumbs
      if (event.breadcrumbs) {
        event.breadcrumbs = event.breadcrumbs.map((b) => {
          if (b.data && typeof b.data === "object") {
            const data = { ...b.data };
            for (const key of Object.keys(data)) {
              if (/password|secret|token|key/i.test(key)) {
                data[key] = "[REDACTED]";
              }
            }
            return { ...b, data };
          }
          return b;
        });
      }
      return event;
    },
  });
}
